<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg fill="currentColor" viewBox="1 1 22 22" id="nut" xmlns="http://www.w3.org/2000/svg">
		<path
			id="primary"
			d="M21.74,11,17.81,4a2,2,0,0,0-1.75-1H7.94A2,2,0,0,0,6.19,4L2.26,11a2,2,0,0,0,0,2l3.93,7a2,2,0,0,0,1.75,1h8.12a2,2,0,0,0,1.75-1l3.93-7A2,2,0,0,0,21.74,11ZM12,15a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"
		></path>
	</svg>
</div>
